module.exports = __webpack_public_path__ + "img/g7.bf177d68.jpg";